import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { locationTypes } from '../LocationTypes';

export const useLocationTypes = () =>
  useQuery({
    queryKey: [QUERY_KEYS.locationTypes],
    queryFn: async () => (await locationTypes.getLocationTypes()).data,
  });
